<template>
    <div>
        <page-title>模版管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/template/edit">添加模版</router-link>
                    </div>
                    <div></div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column label="ID" prop="id" width="80px"></el-table-column>
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="类型" prop="type" width="100px">
                    <template slot-scope="scope">{{types[scope.row.type]}}</template>
                </el-table-column>
                <el-table-column label="审核状态" prop="approval_status" width="100px">
                    <template slot-scope="scope">{{approval_status[scope.row.approval_status]}}</template>
                </el-table-column>
                <el-table-column label="上架状态" prop="status" width="100px">
                    <template slot-scope="scope">{{status[scope.row.status]}}</template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                        <router-link v-if="scope.row.is_delete === 0"
                                     :to="'/dashboard/admin/template/edit?id=' + scope.row.id">编辑
                        </router-link>
                        <span v-else style="color: #999">已删除</span>
                        <span class="text-split">|</span>
                        <el-button v-if="scope.row.is_delete === 0" type="text" @click="deleteItem(scope.row)">删除
                        </el-button>
                        <el-button v-else type="text" @click="recoveryItem(scope.row)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width: 767px) {
        .cell div {
            display: block !important;
        }

        .cell div div {
            margin-left: 0 !important;
            text-align: center;
        }
    }
</style>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    data() {
        return {
            types: {
                'home': '首页',
                'diy': 'DIY'
            },
            status: {
                0: '下架',
                1: '上架'
            },
            approval_status: {
                0: '待审核',
                1: '通过',
                2: '未通过'
            },
            loading: false,
            list: null,
            pagination: null,
            keyword: ''
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/template/index',
                    params: {
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteItem(item) {
            new Promise(resolve => {
                this.$confirm('确认删除该内容?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = 1
                this.loading = true
                axios({
                    url: 'admin/template/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        item.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryItem(item) {
            const data = helper.clone(item)
            data.is_delete = 0
            this.loading = true
            axios({
                url: 'admin/template/update',
                method: 'post',
                data: data
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    item.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>
